import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Start expanded by default
    this.expanded = true
    console.log("Collapse controller connected", this.element)
  }

  toggle() {
    console.log("Toggle clicked, current state:", this.expanded)
    this.expanded = !this.expanded

    if (this.expanded) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
    this.iconTarget.style.transform = "rotate(0deg)"

    // Remove max-height after transition for dynamic content
    setTimeout(() => {
      if (this.expanded) {
        this.contentTarget.style.maxHeight = "none"
      }
    }, 300)
  }

  collapse() {
    this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
    
    // Force reflow
    this.contentTarget.offsetHeight

    this.contentTarget.style.maxHeight = "0"
    this.iconTarget.style.transform = "rotate(-90deg)"
  }
}
